
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/career-path",
      function () {
        return require("private-next-pages/career-path/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/career-path"])
      });
    }
  